import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from '@platform/i18n';
import { useForm } from 'react-hook-form';
import { FormSheet } from '../FormSheet.tsx';
import { SenderFields } from './SenderFields.tsx';
import {
  senderBodyOf,
  senderFormOf,
  senderFormSchema,
  type SenderBody,
  type SenderFormValues,
  type SenderProfile,
} from './sender.ts';

export type SenderSheetProps = {
  profile: SenderProfile | null;
  submitting: boolean;
  errorMessage: string | null;
  onClose: () => void;
  onSubmit: (body: SenderBody) => void;
};

export const SenderSheet = ({ profile, submitting, errorMessage, onClose, onSubmit }: SenderSheetProps) => {
  const { t } = useTranslation();
  const form = useForm<SenderFormValues>({
    resolver: zodResolver(senderFormSchema),
    defaultValues: senderFormOf(profile),
    mode: 'onBlur',
  });

  return (
    <FormSheet
      open
      formId="sender-form"
      title={t('sender.title')}
      submitting={submitting}
      errorMessage={errorMessage}
      onClose={onClose}
      onSubmit={(event) => {
        void form.handleSubmit((values) => {
          onSubmit(senderBodyOf(values));
        })(event);
      }}
    >
      <p>{t('sender.help')}</p>
      <SenderFields form={form} />
    </FormSheet>
  );
};
